import { Breadcrumb, Button, Flex, Space, Spin } from "antd";
import MainLayout from "components/layouts/MainLayout/MainLayout_2";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import { PERMISSIONS_CONFIG } from "../data/payrollPeriod";
import PayrollPeriodMenu from "./PayrollPeriodMenu";

const PayrollPeriod = ({
    payrollPerMonth = [],
    isModalOpen = false,
    setPayrollPerMonthList = () => { },
    isModalOpenPerMonth = false,
    setModalOpenPerMonth = () => { },
    payrollPeriodList = [],
    isLoading = true,
    getPayrollPerMonth = () => { },
    onCancelPerMonth = () => { },
    incomeForSpecialPeriod = [],
    deductionForSpecialPeriod = [],
    setModalOpen = () => { },
    getPayrollPeriodList = () => { },
    payrollPeriodListPage = {},
    getPayrollPeriodListPage = () => { },
    setYear = () => { },
    setMonth = () => { },
    setStatusFlag = () => { },
    employmentTypeDropdown = () => { },
    getSPecialPeriodDropdown = () => { },
    specialPeriodDropdown = () => { },
    createPayrollSpecialPeriod = () => { },
    onCreateSpecial = () => { },
    onCancel = () => { },
    handleOk = () => { },
    onPayrollClick = () => { },
    handleVisible = () => { },
    visible = false,
    pagination = {},
    getPayrollPeriodDetails = () => { },
    onViewPayrollPeriodCalculateDetails = () => { },
    getPayrollPeriodCalculateDetailsModal = () => { },
    isSpecialPeriodModalOpen = false,
    setIsSpecialPeriodModalOpen = () => { },
    onCreateSpecialSubmit = () => { },
    updatePeriodOptions = () => { }
}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    const roles = useSelector((state) => state.company.roles);
    const [permissions, setPermissions] = useState({})
    const isLoadingPage = useSelector((state) => state.payroll.isLoadingPage);


    const initialTab = location.state?.activeTab || "payrollOngoing";
    const [activeTab, setActiveTab] = useState(initialTab);

    useEffect(() => {
        if (location.state?.activeTab) {
            setActiveTab(location.state.activeTab);
        }
    }, [location.state]);

    const getPermissions = (menu) => {
        const permissions = PERMISSIONS_CONFIG[menu] || {};
        return Object.keys(permissions).reduce((acc, perm) => {
            acc[perm] = roles.includes(permissions[perm]);
            return acc;
        }, {});
    };

    const [selectedMenu, setSelectedMenu] = useState(initialTab);

    const menuBreadcrumbMapping = {
        'payrollOngoing': t("payroll.onGoing"),
        'payrollAll': t("payroll.all"),
    };

    useEffect(() => {
        const newPermissions = getPermissions(activeTab);
        setPermissions(newPermissions);
    }, [activeTab, roles])

    useEffect(() => {
        setSelectedMenu(activeTab);
    }, [activeTab]);

    return (
        <MainLayout>
            <Space size={24} direction="vertical" style={{ width: "100%" }}>
                <Flex justify="space-between">
                    <Flex vertical>
                        <Breadcrumb items={[
                            { title: t("home.header"), href: "/" },
                            { title: t("payroll.header"), href: "" },
                            { title: menuBreadcrumbMapping[selectedMenu] || t("payment_period.period.header") }
                        ]} />
                        <h2>{menuBreadcrumbMapping[selectedMenu] || t("payment_period.period.header")}</h2>
                    </Flex>

                    {activeTab === "payrollAll" && !isLoading && (
                        <Flex gap={10} align="center">
                            <Button
                                onClick={() => {
                                    navigate("/payroll/create")
                                }}
                                style={{ width: "max-content", height: "max-content", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "10px 16px", border: "none" }}
                                type="primary"
                                disabled={!permissions?.CREATE_PERIOD}
                            >
                                <Flex align="center" justify="center" gap={8}>
                                    <CreateIcon />
                                    {t("payroll.create_period")}
                                </Flex>
                            </Button>
                            {/* <Button
                            onClick={() => {
                                setModalOpen(true)
                            }}
                            style={{ width: "max-content", height: "max-content", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "10px 16px", border: "none" }}
                            type="primary"
                        >
                            <Flex align="center" justify="center" gap={8}>
                                <CreateIcon />
                                {t("payroll.create_special_period")}
                            </Flex>
                        </Button> */}
                        </Flex>
                    )}
                </Flex>
                <Spin spinning={isLoadingPage || isLoading}>
                    <PayrollPeriodMenu
                        updatePeriodOptions={updatePeriodOptions}
                        getPayrollPeriodDetails={getPayrollPeriodDetails}
                        onViewPayrollPeriodCalculateDetails={onViewPayrollPeriodCalculateDetails}
                        getPayrollPeriodCalculateDetailsModal={getPayrollPeriodCalculateDetailsModal}
                        payrollPerMonth={payrollPerMonth}
                        handleVisible={handleVisible}
                        visible={visible}
                        setYear={setYear}
                        setMonth={setMonth}
                        setStatusFlag={setStatusFlag}
                        setPayrollPerMonthList={setPayrollPerMonthList}
                        getPayrollPerMonth={getPayrollPerMonth}
                        onCancelPerMonth={onCancelPerMonth}
                        isModalOpenPerMonth={isModalOpenPerMonth}
                        setModalOpenPerMonth={setModalOpenPerMonth}
                        isModalOpen={isModalOpen}
                        setModalOpen={setModalOpen}
                        payrollPeriodList={payrollPeriodList}
                        isLoading={isLoading}
                        incomeForSpecialPeriod={incomeForSpecialPeriod}
                        deductionForSpecialPeriod={deductionForSpecialPeriod}
                        getPayrollPeriodList={getPayrollPeriodList}
                        payrollPeriodListPage={payrollPeriodListPage}
                        getPayrollPeriodListPage={getPayrollPeriodListPage}
                        employmentTypeDropdown={employmentTypeDropdown}
                        getSPecialPeriodDropdown={getSPecialPeriodDropdown}
                        specialPeriodDropdown={specialPeriodDropdown}
                        createPayrollSpecialPeriod={createPayrollSpecialPeriod}
                        onCreateSpecial={onCreateSpecial}
                        onCancel={onCancel}
                        handleOk={handleOk}
                        onPayrollClick={onPayrollClick}
                        pagination={pagination}
                        setActiveTab={setActiveTab}
                        permissions={permissions}
                        isSpecialPeriodModalOpen={isSpecialPeriodModalOpen}
                        setIsSpecialPeriodModalOpen={setIsSpecialPeriodModalOpen}
                        onCreateSpecialSubmit={onCreateSpecialSubmit}
                    />
                </Spin>
            </Space>
        </MainLayout >
    );
}

export default PayrollPeriod;
